module.exports = __webpack_public_path__ + "img/RS-PPE-ICONS-CROSS.f42a575f.svg";